<template>

  <div id="edu-list">
      
    <v-card>
      <v-card-title primary-title class="amber lighten-1">
        <v-layout align-baseline justify-space-between>
          <h3 class="headline pb-2 blue--text text--darken-4"><v-icon color="blue darken-4">school</v-icon> Formations</h3>
          <SectionsLayout
            :cv_id='cv_id'
            section='edu'
          >
          </SectionsLayout>
        </v-layout>
      </v-card-title>
        
        <v-expansion-panel popout>
          <v-layout>
            <v-flex xs12>
              <transition-group name="list-item">
                <v-expansion-panel-content 
                  v-for="(item, index) in modelObjects" :key="item.id" 
                  hide-actions 
                >
                  <div slot="header">
    
                    <v-layout align-start justify-space-between class="mt-1">
                      <v-flex py-0 my-0>
                        <h4 v-if="item.title" class="title font-weight-regular">{{ item.title }}</h4>
                        <h4 v-else class="title font-weight-regular">Nouvelle Formation </h4>
                      </v-flex>
                      
                      <v-flex py-0 my-0>
                        <itemBar
                          :item="item"
                          :index="index"
                          v-on:update-item="updateModelObject"
                          v-on:delete-item="deleteModelObject"
                          v-on:pullup-item="pullUpItem"
                          v-on:pulldown-item="pullDownItem"
                        >
                        </itemBar>
                      </v-flex>
                    </v-layout>

                    <div class="d-inline-flex ">
                      <h6 class="subheading" v-if="item.institution"> {{ item.institution }} :</h6> 
                      <h6 v-if="item.start_year" class="subheading ml-2"> {{ item.start_year }} </h6>
                      <h6 v-if="item.end_year" class="subheading ml-2"> - {{ item.end_year }} </h6>
                      <h6 v-if="item.is_current" class="subheading ml-2"> - En cours </h6>
                    </div>
                  
                  </div>

                  <EduComponent
                    :isLoading="isLoading"
                    :itemCollapseShow="itemCollapseShow"
                    :item="item"
                    :index="index"
                    :arraylen="modelObjects.length"
                    :cv_id="cv_id"
                    
                    v-on:delete-item="deleteModelObject"
                    v-on:update-item="updateModelObject"
                    
                  ></EduComponent>

                </v-expansion-panel-content>
              </transition-group>
            </v-flex>
          </v-layout>
        </v-expansion-panel>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn outline round color="info" v-on:click="addModelObject(); showIt()">
            <v-icon left>add_circle_outline</v-icon>
            Ajouter une formation
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
      
  </div>

</template>

<script>
  import { mixin_ajax } from './mixin_ajax_vue.js';
  import { mixin_pullupdown } from './mixin_pullupdown.js'
  import EduComponent from './EduComponent.vue';
  import SectionsLayout from '../components/SectionsLayout';
  import ItemBar from '../components/ItemBar';

  export default {
      mixins: [mixin_ajax, mixin_pullupdown],
      props: ['cv_id'],
      components: {
          EduComponent,
          SectionsLayout,
          ItemBar,
      },
      data: function() {
        return {
          dialog: {},
          api_url: '/api/' + this.cv_id + '/education/',
          modelObjects: [],
          newModelObject: function() {
            return { 
              'display_order': this.modelObjects.length,
              'curriculum': this.cv_id,
            }
          },
          isLoading: false,
        }
      },
     
       
    }
</script>

<style>

/* transformations
NOTES :
opacity = 0 ---> invisible
opacity = 1 ---> visible
*/

/* tout au début et tout à la fin : disparait et est diminué de moitié */
.list-item-enter, .list-item-leave-to /* .list-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: scale(0.5);
}

.list-item-move {
    transition: transform 1s;
    }

.list-item-enter-active, .list-item-leave-active {
  transition: opacity 0.3s, transform 0.3s;
  transform-origin: left center;
}





</style>
